export enum ActivityType {
    Message = "message",
    Typing = "typing",
    Event = "event",
}
